const env = {
  API_URL: process.env.REACT_APP_API_BASE_URL,
  G_MAP_API_KEY: process.env.REACT_APP_G_MAP_API_KEY || '',
  // web-v2 runs on 3030 in development (see its package.json start-mac script). This
  // pointed at 3031, so "Access" from the merchant list always opened a dead port and
  // showed a white screen. superadmin-v2 itself should run on 3031 to avoid the clash.
  ACCESS_URL: process.env.REACT_APP_ACCESS_URL,
}

export default env
